import { useEffect, useState } from 'react';
import { languageManager } from '@/lib/language-manager';
import { FullscreenLoadingSpinner } from '@/components/ui/loading-spinner';

interface I18nProviderProps {
  children: React.ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Moderný prístup: počkaj na načítanie všetkých namespace-ov
    const initI18n = async () => {
      try {
        await languageManager.initialize();
        setIsReady(true);
      } catch (error) {
        console.error('Error initializing language manager:', error);
        // Fallback - nastavíme ako pripravené aj pri chybe
        setIsReady(true);
      }
    };

    initI18n();
  }, []);

  // Moderný prístup: zobraz skeleton počas načítavania
  if (!isReady) {
    return <FullscreenLoadingSpinner text="Načítavam jazykové súbory..." />;
  }

  return <>{children}</>;
}



